import { render, staticRenderFns } from "./CustomerShowButton.vue?vue&type=template&id=159691a7&scoped=true&"
import script from "./CustomerShowButton.vue?vue&type=script&lang=ts&"
export * from "./CustomerShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerShowButton.vue?vue&type=style&index=0&id=159691a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159691a7",
  null
  
)

export default component.exports